import { C3Text } from "../text/CustomText";
import { BaseButton } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { Theme } from "../../Theme";

function FullWidthButton({
    onClick,
    text,
    isActive = true,
    backgroundColor = Theme.color.indigo500,
    icon,
    padding = "15px 0",
    border,
}) {
    let activeColor = backgroundColor;
    let activeHoverColor;
    let inactiveColor;
    let inactiveHoverColor;
    let fontColor;
    if (activeColor === Theme.color.indigo500) {
        activeHoverColor = Theme.color.indigo700;
        inactiveColor = Theme.color.gray400;
        inactiveHoverColor = Theme.color.gray400;
        fontColor = Theme.color.white;
    } else if (activeColor === Theme.color.white) {
        activeHoverColor = Theme.color.neutral100;
        inactiveColor = Theme.color.white;
        inactiveHoverColor = Theme.color.neutral100;
        fontColor = Theme.color.gray500;
    }

    return (
        <BaseButton
            width={"100%"}
            backgroundColor={isActive ? activeColor : inactiveColor}
            border={border}
            borderRadius={"9px"}
            padding={padding}
            hoverBackgroundColor={isActive ? activeHoverColor : inactiveHoverColor}
            onClick={isActive ? onClick : () => { }}
        >
            {icon && <CustomIcon iconName={icon} size={"17px"} cursor={"pointer"} />}
            <C3Text fontWeight={"600"} fontColor={fontColor}>
                {text}
            </C3Text>
        </BaseButton>
    );
}

export default FullWidthButton;
